import { useEffect, useState } from "react";
import { whatsappUrl } from "@/lib/content";
import { useLanguage } from "@/lib/language";

export function EnquiryComposer() {
  const { t, enquiryDraft, setEnquiryDraft } = useLanguage();
  const [ready, setReady] = useState(false);
  useEffect(() => setReady(true), []);
  const { topic, detail } = enquiryDraft;
  const topics = [
    { value: "unsure", label: { en: "Help me choose", ar: "أحتاج إلى تحديد المسار" } },
    { value: "iso", label: { en: "ISO preparation", ar: "التحضير للأيزو" } },
    { value: "registration", label: { en: "Supplier registration", ar: "تسجيل الموردين" } },
  ];
  const message =
    t({
      en: "Hello IraqCert, I would like to discuss my requirement.",
      ar: "مرحباً عراق سيرت، أود مناقشة متطلب شركتي.",
    }) +
    "\n" +
    t(topics.find((x) => x.value === topic)!.label) +
    (detail.trim() ? "\n" + detail.trim() : "");
  return (
    <div className="ic-enquiry" aria-labelledby="enquiry-heading">
      <h2 id="enquiry-heading">
        {t({ en: "Start with your requirement", ar: "ابدأ بمتطلب شركتك" })}
      </h2>
      <p>
        {t({
          en: "A short note is enough. Your activity, location and buyer requirement help us understand the work.",
          ar: "تكفي رسالة قصيرة. يساعدنا نشاط الشركة وموقعها ومتطلب الجهة المشترية على فهم العمل المطلوب.",
        })}
      </p>
      {!ready && (
        <p className="ic-small">
          {t({
            en: "The optional draft editor needs JavaScript. You can continue directly in WhatsApp, call or email below.",
            ar: "يتطلب محرر المسودة الاختياري JavaScript. يمكنك المتابعة مباشرة عبر واتساب أو الاتصال أو البريد الإلكتروني أدناه.",
          })}
        </p>
      )}
      <label htmlFor="enquiry-topic">
        {t({ en: "What do you need?", ar: "ما الدعم الذي تحتاجه؟" })}
      </label>
      <select
        id="enquiry-topic"
        disabled={!ready}
        value={topic}
        onChange={(e) => setEnquiryDraft((draft) => ({ ...draft, topic: e.target.value }))}
      >
        {topics.map((x) => (
          <option key={x.value} value={x.value}>
            {t(x.label)}
          </option>
        ))}
      </select>
      <label htmlFor="enquiry-detail">
        {t({ en: "Your requirement (optional)", ar: "متطلبك (اختياري)" })}
      </label>
      <textarea
        id="enquiry-detail"
        disabled={!ready}
        rows={4}
        maxLength={800}
        value={detail}
        onChange={(e) => setEnquiryDraft((draft) => ({ ...draft, detail: e.target.value }))}
        aria-describedby="enquiry-privacy"
        placeholder={t({
          en: "Company activity, location, buyer or standard, target date…",
          ar: "نشاط الشركة، الموقع، الجهة المشترية أو المواصفة، الموعد المستهدف…",
        })}
      />
      <a
        href={`${whatsappUrl}?text=${encodeURIComponent(message)}`}
        target="_blank"
        rel="noopener noreferrer"
        data-cta="contact-draft-whatsapp"
        className="ic-button"
      >
        {t({ en: "Continue in WhatsApp", ar: "تابع عبر واتساب" })}
      </a>
      <p id="enquiry-privacy" className="ic-small">
        {t({
          en: "Opens WhatsApp with a draft. Nothing is sent automatically. Please do not include confidential documents here.",
          ar: "يفتح واتساب بمسودة رسالة. لا تُرسل الرسالة تلقائياً. يرجى عدم إدراج وثائق سرية هنا.",
        })}
      </p>
    </div>
  );
}
